module.exports = __webpack_public_path__ + "media/components/breakheader/static/surf-alert@2-8dedc460177b0a0fd80fc60de3abcc00.png";